import storage from '@/utils/storage';
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
// SCN06 

const CreatePasswordInformPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const props = location.state || null;

    // Effect hook: runs on component mount and when props or navigate change
    // If user lands here without props, redirect to home
    // If password creation was successful, clear storage and show success modal
    useEffect(() => {
        if (!props) {
            navigate('/');
        } else if (props && props.showSuccessModal == true) {
            storage.clearAll();
            setShowSuccessModal(true)
        }
    }, [navigate, props]);

    // Handler for going back to login page (used on logo click)
    const backToLogin = () => {
        navigate('/login');
    };

    // If success modal should not be shown, render nothing
    if (!showSuccessModal) {
        return <></>
    }

    // Render UI
    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
                        <img className="m-1" src={logoCCBJI} alt="Logo 1" style={{ height: '90%' }} />
                        <img className="m-1" src={logoFVJ} alt="Logo 1" style={{ height: '90%' }} />
                    </li>
                </ul>
            </nav >

            <div className="container-fluid background-cover-external">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active">初期パスワード変更完了</li>
                </ol>
                <div className="jumbotron">
                    <div className="section">
                        <div className="card-body" style={{ minHeight: '45vh' }}>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <p>
                                        <span>登録が完了しました。</span> <br />
                                        <span>登録完了メールを送信しましたのでメールをご確認ください。</span>
                                    </p>
                                    <p>ログインは<Link className="text-primary" to="/login"><u>コチラ</u></Link>。</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default CreatePasswordInformPage;
